import { gql } from "@apollo/client";

export const GET_ENVIO_ESTADOS = gql`
  query GetEnvioEstados {
    envioEstados {
      idEstado
      abreviacion
      descripcion
    }
  }
`;